module.exports = __webpack_public_path__ + "img/transactions.c36db49f.svg";